import { useState, useCallback } from 'react'
import { useToggleChat } from '@components/chat/context/ChatStateContext'
import Modal from '@components/modal/Modal'
import ChatContainer from '@components/chat/components/ChatContainer'
import ChatList from '@components/chat/views/ChatList'
import ChatMessages from '@components/chat/views/ChatMessages'

export const VIEWS = {
    CHATS: 'chat_list',
    MESSAGES: 'chat_messages',
}

const ChatViewHandler = ({ user, isOpen }) => {
    const closeWindow = useToggleChat()

    const [view, setView] = useState(VIEWS.CHATS)
    const [chat, setChat] = useState(null)

    const openChat = useCallback((chat) => {
        if (chat) {
            setChat(chat)
            setView(VIEWS.MESSAGES)
        }
    }, [])

    const closeChat = useCallback(() => {
        setChat(null)
        setView(VIEWS.CHATS)
    }, [])

    return (
        <Modal open={isOpen} onClose={close}>
            <ChatContainer>
                { view === VIEWS.CHATS &&
                    <ChatList
                        user={user}
                        openChat={openChat}
                        closeWindow={closeWindow} />}

                { view === VIEWS.MESSAGES &&
                    <ChatMessages
                        user={user}
                        chat={chat}
                        closeChat={closeChat}
                        closeWindow={closeWindow} />}
            </ChatContainer>
        </Modal>
    )
}

export default ChatViewHandler